import PropTypes from 'prop-types';

export const colorData = PropTypes.shape({
	ratio: PropTypes.number.isRequired,
	largeText: PropTypes.bool.isRequired,
	passesAA: PropTypes.bool.isRequired,
	isPotential: PropTypes.bool.isRequired,
});
